import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ListHeading, ListSubheading, List, Badge } from '@oliasoft-open-source/react-ui-library';
import translations from 'src/internationalisation/translation-map.json';
import { convertToKebabCase } from 'client/common/utils/string-utils.ts';

const SectionsList = ({ sectionTypes, sectionTypeSelected, operations }) => {
  const { t } = useTranslation();

  const sectionOperationCounts = useMemo(() => {
    const counts = new Map();
    (operations ?? []).forEach((op) => {
      counts.set(op.linkedSectionType, (counts.get(op.linkedSectionType) ?? 0) + 1);
    });
    return counts;
  }, [operations]);

  return (
    <>
      <ListHeading testId="section-types-list-heading" name={t(translations.settings_linkedSections)} />
      <ListSubheading
        testId="section-types-list-subheading"
        item={{
          name: `${t(translations.settings_sectionTypes)} (${sectionTypes.length})`,
        }}
      />
      <List
        testId="section-types-list"
        list={{
          items: sectionTypes.map((section) => {
            const operationCount = sectionOperationCounts.get(section.linkedSectionId) ?? 0;

            return {
              ...section,
              testId: `section-types-list-${convertToKebabCase(
                `${section.sectionName} ${section.sectionTypeName ?? ''}`,
              )}-item`,
              name: `${section.sectionName} ${section.sectionTypeName ?? ''}`,
              onClick: () => sectionTypeSelected(section.linkedSectionId),
              actions: [
                {
                  childComponent: (
                    <Badge
                      title={String(operationCount)}
                      color={operationCount ? '#cccccc' : ''}
                      textColor={'#ffffff'}
                    />
                  ),
                },
              ],
            };
          }),
        }}
        noHeader
      />
    </>
  );
};

export { SectionsList };
